import { render, staticRenderFns } from "./ValProductosList.vue?vue&type=template&id=5d7660ba&"
import script from "./ValProductosList.vue?vue&type=script&lang=js&"
export * from "./ValProductosList.vue?vue&type=script&lang=js&"
import style0 from "./ValProductosList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports